<template>
    <el-card shadow="hover">
        <label slot="header">鼠标浮窗</label>
        <el-divider content-position="left">鼠标左键/右键点击以下位置弹出位置浮窗</el-divider>
        <div class="follow-plane" @click="e => $refs.follow.show(e)" @contextmenu.prevent="e => $refs.follow.show(e)">点击面板</div>
        <j-follow ref="follow" :width="100" :height="200">
            <div class="follow-menu">
                <div v-for="(item, i) in followList" :key="i" class="follow-menu-item">{{item.name}}</div>
            </div>
        </j-follow>
    </el-card>
</template>

<script>
    import JFollow from "./JFollow";
    export default {
        components: {
            JFollow
        },
        data() {
            return {
                followList: [
                    { name: '选项1' },
                    { name: '选项2' },
                    { name: '选项3' },
                    { name: '选项4' },
                    { name: '选项5' }
                ],
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style lang="scss">
    .follow-plane {
        height: 300px;
        background-color: rgba(0,0,0,.05);
        color: rgba(0,0,0,.2);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .follow-menu {
        padding: 5px;
        border-radius: 5px;
        background: rgba(8, 21, 63, .7);
        .follow-menu-item {
            text-align: center;
            font-size: 14px;
            background: rgba(36,203,234,0.2);
            color: rgba(255,255,255,0.6);
            box-sizing: border-box;
            height: 20px;
            line-height: 20px;
            border-radius: 2px;
            &:hover {
                background-color: rgba(32, 207, 240, 1);
                color: #020E19;
            }
            + .follow-menu-item {
                margin-top: 5px;
            }
        }
    }
</style>
